import { render, staticRenderFns } from "./ReportInputTotal.vue?vue&type=template&id=2407a1f6&scoped=true"
import script from "./ReportInputTotal.vue?vue&type=script&lang=js"
export * from "./ReportInputTotal.vue?vue&type=script&lang=js"
import style0 from "./ReportInputTotal.vue?vue&type=style&index=0&id=2407a1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407a1f6",
  null
  
)

export default component.exports